/* Bean Shipper — prepaid subscription PDP (sections/product__prepaid-subscription.liquid): the Grind row.
   The prepaid variants have no grind option, so the choice is sent as the line property "Grind" through
   the hidden input [data-bsq-grind-input] (the theme's ajax cart reads the form with FormData). The
   coffee and bag choice stays with bean-shipper.js. Added 29 Sep 2026. */
(function () {
  function init() {
    var r = document.querySelector('.bsq[data-bsq-root]');
    if (!r || r.__bsqGrind) return;
    r.__bsqGrind = true;
    var input = r.querySelector('[data-bsq-grind-input]');
    if (!input) return;
    r.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bsq-grind]');
      if (!b || !r.contains(b)) return;
      var g = b.getAttribute('data-bsq-grind');
      input.value = g;
      Array.prototype.forEach.call(r.querySelectorAll('[data-bsq-grind]'), function (x) {
        var on = x === b;
        x.classList.toggle('sel', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var pick = r.querySelector('[data-bsq-pick-grind]');
      if (pick) pick.textContent = g;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
